function EventoTerminado() {
  return (
    <div style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100vh"}}>
      <span style={{fontSize: 20}}>Este evento ha terminado</span>
    </div>
  );
}

export default EventoTerminado;
